// Ported from Studio Playground frontend/src/components/booth/CareCard.jsx.
import React from 'react';
import { MessageCircle, Phone } from 'lucide-react';

const CareCard = ({ kind, onClose }) => {
  if (!kind) return null;

  return <div
    className="lyrics-care-backdrop"
    role="dialog"
    aria-modal="true"
    aria-labelledby="booth-care-title"
  >
    <div className="lyrics-care-card">
      <p className="lyrics-care-eyebrow">Right now</p>
      <h2 id="booth-care-title">You don't have to carry it alone</h2>
      <p>
        If you're going through it right now, talk to someone. Call or text 988, any time, free.
      </p>
      {kind === 'harmed' && <p>
        If someone is hurting you, call or text the Childhelp line at 1-800-422-4453.
      </p>}
      <div className="lyrics-care-actions">
        <a href="tel:988"><Phone size={18} /> Call 988</a>
        <a href="sms:988"><MessageCircle size={18} /> Text 988</a>
        <button type="button" onClick={onClose}>Keep writing</button>
      </div>
    </div>
  </div>;
};

export default CareCard;
